<template lang="pug">
section#v-features: .container
  h3 TechOrange 年度趨勢論壇
  h2 走向 2030 的未來指南
  h4: span
    | AI人工智慧強勢改變世界
    |
    | 台灣無法置身事外
  ul
    li
      em 500
      | 個未來十年不能不知道的重要科技趨勢
    // li
    //   em 20
    //   | 個主題演講與討論
    li
      em 5
      | 大AI應用範疇
    li
      em 1
      | 張你可以按圖索驥持續驗證的未來地圖
  h5
    | 2019.8.31
    br(v-if='$store.state.mobile')
    |
    | 驚見未來，我們不見不散
  a(href='https://kktix.com/tickets_widget?slug=connect2019', target='_blank') 立即購票
</template>

<script>
export default {
  name: 'Features',
}
</script>

<style lang="sass" scoped>
@import '~@/mixin.sass'

#v-features
  +background((url(~@/assets/features-background-1.png), url(~@/assets/features-background-2.png)), (392px, 283px), no-repeat, (left top 500px, right top 400px))
  padding-bottom: 100px
  padding-top: 80px
h3
  +font(30px, white, null, .75px, 500, center)
  margin-bottom: 26px
h2
  +font(50px, #DFFF00, null, 1.25px, bold, center)
  margin-bottom: 40px
h4
  margin-bottom: 25px
  text-align: right
  span
    +font(24px, black, null, .6px, bold, center)
    background-color: #DFFF00
    display: inline-block
    padding: 8px 16px
ul
  height: 410px
  list-style-type: none
  margin-bottom: 100px
  position: relative
  li
    +font(26px, white, null, .65px, bold)
    em
      +font(60px, #DFFF00, null, 1.5px, 800)
      display: block
      font-family: 'Montserrat Alternates'
      margin-bottom: 10px
    &:nth-child(1)
      +position(absolute, 0, null, null, 0)
      animation: floating 15s infinite both
    &:nth-child(2)
      +position(absolute, 150px, null, null, 185px)
      animation: floating 15s infinite 2s both
    &:nth-child(3)
      +position(absolute, 150px, null, null, 500px)
      animation: floating 15s infinite 5s both
    &:nth-child(4)
      +position(absolute, 300px, null, null, 500px)
      animation: floating 15s infinite 7s both
h5
  +font(34px, white, null, null, 800, center)
  font-family: 'Montserrat Alternates'
  margin-bottom: 50px
a
  +border(3px, #DFFF00, 100px)
  +flex(center, center)
  +font(30px, white, null, .75px, bold)
  +size(320px, 70px)
  margin-left : auto
  margin-right: auto
  &:hover
    text-decoration: none

@media (max-width: 1023px)
  #v-features
    +background(url(~@/assets/features-background-2.png), 200px, null, right top 250px)
    padding-bottom: 35px
    padding-top: 50px
  h3
    +font(18px, null, null, .44px)
    margin-bottom : 10px
  h2
    +font(28px, null, null, .7px)
    margin-bottom: 20px
  h4
    margin-bottom: 30px
    text-align: center
    span
      +font(14px, null, 18px, .35px)
      padding: 7px 11px
  ul
    height: 400px
    margin-bottom: 60px
    li
      +font(16px, null, 24px, .4px)
      em
        +font(40px, null, 40px, 1px)
        margin-bottom: 5px
      &:nth-child(1)
        +position(null, null, null, null, calc(50% - 160px))
      &:nth-child(2)
        +position(null, 100px, null, null, calc(50% - 110px))
      &:nth-child(3)
        +position(null, 200px, null, null, calc(50% - 110px))
      &:nth-child(4)
        +position(null, 300px, null, null, calc(50% - 60px))
  h5
    +font(18px, null, 26px, 1.22px)
    margin-bottom: 20px
  a
    +font(22px, null, null, .55px)
    +size(180px, 55px)
</style>
